/* Creator partner pages: apply the creator code to the cart in place, or copy it.
   The Apply link works without JavaScript too (Shopify's /discount/<code> route
   sets the code and redirects back here). */
(function () {
  'use strict';

  function readCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : '';
  }

  function init(root) {
    if (root.dataset.coReady) return;
    root.dataset.coReady = '1';

    var code = (root.dataset.code || '').toUpperCase();
    var plate = root.querySelector('[data-co-plate]');
    var apply = root.querySelector('[data-co-apply]');
    var copy = root.querySelector('[data-co-copy]');
    var status = root.querySelector('[data-co-status]');
    if (!plate || !code) return;

    function say(key) {
      if (status) status.textContent = status.dataset[key] || '';
    }

    function markApplied(animate) {
      plate.dataset.state = 'applied';
      if (apply) {
        apply.setAttribute('aria-disabled', 'true');
        apply.setAttribute('tabindex', '-1');
      }
      if (animate) root.setAttribute('data-applied', '');
    }

    // Already on the cart from an earlier visit or the no-JS route.
    if (readCookie('discount_code').toUpperCase() === code) {
      markApplied(false);
      say('applied');
    }

    if (apply) {
      apply.addEventListener('click', function (event) {
        event.preventDefault();
        if (plate.dataset.state === 'applied' || plate.dataset.state === 'busy') return;
        plate.dataset.state = 'busy';
        fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin', redirect: 'follow' })
          .then(function (response) {
            if (!response.ok) throw new Error('status ' + response.status);
            markApplied(true);
            say('applied');
          })
          .catch(function () {
            plate.dataset.state = 'idle';
            say('failed');
          });
      });
    }

    if (copy) {
      copy.addEventListener('click', function () {
        var done = function () { say('copied'); };
        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard.writeText(code).then(done, fallback);
        } else {
          fallback();
        }
        function fallback() {
          var field = document.createElement('textarea');
          field.value = code;
          field.setAttribute('readonly', '');
          field.style.position = 'fixed';
          field.style.opacity = '0';
          document.body.appendChild(field);
          field.select();
          try { document.execCommand('copy'); done(); } catch (e) { /* the code stays selectable on the plate */ }
          document.body.removeChild(field);
        }
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-co]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
